import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import * as api from "../../../api";


export const useIncidentsQuery = (incidentsFilters={}) => {
    const query = useQuery({
        queryKey: ['public', 'incidents', incidentsFilters],
        queryFn: () => api.Public.Incidents.getIncidents(incidentsFilters),
        keepPreviousData: true
    });

    // Prefetch the next page!
    const queryClient = useQueryClient()
    const {isPreviousData} = query;
    const hasMoreData = query.data?.page_count > incidentsFilters.pageIndex + 1;

    // note that Incident should be memorized to avoid useless prefetch
    useEffect(() => {
        if (!isPreviousData && hasMoreData) {
            const nextPageFilter = {...incidentsFilters, pageIndex: incidentsFilters.pageIndex + 1}
            queryClient.prefetchQuery({
                queryKey: ['public', 'incidents', nextPageFilter],
                queryFn: () => api.Incidents.getIncidents(nextPageFilter),
            })
        }
    }, [isPreviousData, hasMoreData, incidentsFilters, queryClient])

    return query;
}


export const useIncidentRegistryQuery = () => {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    return useQuery({
        queryKey: ['registry', 'incident', locale],
        queryFn: () => api.Registry.getIncidentRegistry(locale),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}

export const useIncidentSettingsQuery = () => {
    return useQuery({
        queryKey: ['settings', 'incident'],
        queryFn: () => api.Settings.getIncidentSettings(),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}

export const useProvincesQuery = (filter) => {
    return useQuery({
        queryKey: ['provinces', filter],
        queryFn: () => api.Territory.getProvinces(filter),
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    })
}

export const useIncidentTotalsQuery = (incidentsFilters={}) => {
    return useQuery({
        queryKey: ['incidentTotals', incidentsFilters],
        queryFn: () => api.Public.Incidents.getIncidentTotals(incidentsFilters),
        keepPreviousData: true,
    });
}